<template>
    <div>
        <BreadCrumb :data="breadCrumb" />
        <b-card no-body class="formGroup">
            <b-tabs pills card :value="activeIndex">
                <b-tab :title="$t('account.wizzard.generalInfo')" @click="pageSettings([false, true], 'General', 0)">
                    <b-card-text>
                        <Form ref="GeneralForm" :loading="loading"  :forms="GeneralForms" :data="accountDetail"/>
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('account.wizzard.zones')" @click="pageSettings([true, false], 'Zone', 1)" >
                    <b-card-text>
                        <ZoneForm :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('account.wizzard.workHours')"  @click="pageSettings([true, false], 'WorkHours', 2)">
                    <b-card-text> 
                        <WorkHours :edit="true" :modalType="pageSettings" :modalEvent="openModal" :hourList="hourList ? hourList : []"/>
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('account.wizzard.alarmState')" @click="pageSettings([true, false], 'Exceptions', 3)"  >
                   <b-card-text>
                        <ExceptionsForm :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('account.wizzard.panelUsers')" @click="pageSettings([true, false], getJWT.isLdapUser ? 'PanelUserLDAP' : 'PanelUser', 4)">
                    <b-card-text>
                        <PanelUsersForm :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                 <b-tab :title="$t('account.wizzard.notifications')" @click="pageSettings([true, false], 'Notification', 5)">
                    <b-card-text> 
                        <NotificationForm :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                 <b-tab :title="$t('account.wizzard.notes')" @click="pageSettings([true, false], 'Note', 6)">
                    <b-card-text> 
                         <NoteForm :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                 <b-tab :title="$t('account.wizzard.tracing')" @click="pageSettings([false, false], 'Tracing', 7)">
                    <b-card-text> 
                         <Tracing :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                 <b-tab :title="$t('account.wizzard.communication')" @click="pageSettings([true, false], 'Communications', 8)">
                    <b-card-text> 
                         <Communication :modalType="pageSettings" :modalEvent="openModal" />
                    </b-card-text>
                </b-tab>
                <b-tab :title="otherTab && $t('account.wizzard.'+otherTab.toLowerCase())" @click="pageSettings([true, false], otherTab, 9)">
                    <b-card-text> 
                          <component v-bind:is="otherTab" :modalType="pageSettings" :modalEvent="openModal" :data="accountDetail"></component>
                    </b-card-text>
                </b-tab>
            </b-tabs>
            <template v-slot:footer class="footer">
                 <div class="accountState"> 
                    <span v-if="accountDetail.active == 1">
                        <b-alert variant="success" show>
                            <b-icon icon="check" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('account.active')}}  </span>
                        </b-alert>
                    </span>
                    <span v-else-if="accountDetail.active == 2">
                        <b-alert variant="danger" show>
                            <b-icon icon="x" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('account.cancel')}} - {{$t('account.cancelMsg')}} </span>
                        </b-alert>           
                    </span>
                    <span v-else>
                        <b-alert variant="warning" show>
                            <b-icon icon="exclamation-triangle-fill" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('general.passife')}} - {{$t('account.passifeMsg')}} </span>
                        </b-alert>                                
                    </span>
                </div>
                <div class="footerButtons">
                    <b-dropdown variant="warning" style="margin-right: 1rem">
                        <template slot="button-content"> 
                            {{$t('account.otherActions')}}
                            </template>
                        <b-dropdown-item @click="otherTabClick('Location', 9)"> {{$t('account.location')}} </b-dropdown-item>
                        <b-dropdown-item @click="otherTabClick('Vacation', 9)"> {{$t('account.vacations')}} </b-dropdown-item>
                        <b-dropdown-item @click="otherTabClick('RemoteUser', 9)"> {{$t('account.remoteUsers')}} </b-dropdown-item>
                        <b-dropdown-item @click="otherTabClick('Cameras', 9)"> Kameraları Aç </b-dropdown-item>
                        <b-dropdown-item @click="otherTabClick('Devices', 9)"> Abone Cihazları </b-dropdown-item>
                         <b-dropdown-item @click="actionEvent(transaction.key, transaction )"> {{$t('account.systemLogs')}} </b-dropdown-item>
                    </b-dropdown>
                    <b-button variant="danger" v-if="tolerans" @click="openModal(true, 'tolerance', hourList[0])"> {{$t('account.tolerances')}} </b-button>
                    <b-button variant="success" v-if="newButton" @click="openModal(true, 'add' )">{{$t('account.addNew')}}</b-button>
                    <b-button variant="primary"  v-if="saveButton" @click="saveData" >{{$t('general.save')}}</b-button>
                </div>
          
            </template>
        </b-card>
         <!-- Modals openModal(true, 'Vacation', {id: $route.params.id}) -->
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import ZoneForm from "./components/ZoneForm"
    import ExceptionsForm from './components/ExceptionsForm'
    import WorkHours from "@/components/WorkHours"
    import PanelUsersForm from "./components/PanelUsersForm"
    import NoteForm from "./components/NoteForm"
    import Modals from "./modals/"
    import NotificationForm from "./components/NotificationForm"
    import Tracing from "./components/Tracing"
    import Communication from "./components/Communication"
    import Vacation from "./components/Vacation"
    import RemoteUser from "./components/RemoteUser"
    import Location from "./components/Location"
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import Cameras from "./components/CameraList"
    import Devices from "./components/DeviceList"
    import {prepareRequestData} from '@/assets/js/custom.js'
    import jwt_decode from "jwt-decode";

    let breadCrumb = [ ]
    export default {
        name: "AccountEdit",
        created: async function(){
            await this.$store.dispatch('getAccountDetail', {id: this.$route.params.id})
            this.pageSettings([false, true], 'General')
        },
        data: function(){
            return {
                GeneralForms: Forms.GeneralForms,
                newButton: false,
                modalOpen: false,
                tolerans: false,
                currentForm: null,
                modalProps: {},
                modalName: null,
                breadCrumb,
                activeIndex: 0,
                otherTab:"",
                saveButton: true
            }
        },
        computed:{
            accountDetail(){
                if(Object.keys(this.$store.getters.getAccountDetail).length>0){
                    this.breadCrumb = [
                        { label: this.$store.getters.getAccountDetail.account_info.account.account_no+" - "+ 
                            this.$store.getters.getAccountDetail.PartNo+" - "+this.$store.getters.getAccountDetail.name,
                            url: "/Accounts/"+this.$route.params.id },
                        { label: i18n.t('pages.account.edit'), url: "/Accounts/"+this.$route.params.id+"/Edit" }
                    ]
                    return this.$store.getters.getAccountDetail
                }else
                    return {} 
                
            },
            getJWT(){
                return jwt_decode(localStorage.getItem('access_token'))
            },
            hourList(){
                return this.$store.getters.getAccountHours
            },
            message(){
                return this.$store.getters.getAccountStatus
            },
            loading(){
                return this.$store.getters.getAccountLoading
            },
        },
        components:{ 
            BreadCrumb, Form, ZoneForm, WorkHours, PanelUsersForm, NoteForm, Modals,ExceptionsForm, NotificationForm, Tracing, Communication,
            Vacation, RemoteUser, Location, Cameras, Devices
        },
        methods:{
            otherTabClick: async function(val, index){
              this.otherTab = val
              await this.pageSettings([true, false], val, index)
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                    if(this.currentForm == 'PanelUser' && this.getJWT.isLdapUser){
                        this.currentForm = 'PanelUserLDAP'
                    }
                    if(this.currentForm == 'PanelUserLDAP' && modal == 'edit'){
                        this.currentForm = 'PanelUser'
                    }
                    console.log(this.currentForm, getJWT.isLdapUse, modal )
                }
            },
            pageSettings: async function(state, form, index){
                console.log(Array.isArray(state) )
                if(Array.isArray(state)){
                    this.newButton = state[0]
                    this.saveButton = state[1]
                }
               
                this.currentForm = form
                this.activeIndex = index
                let params = {parent_id: this.$route.params.id}
                switch(form){
                    case 'General':
                        await this.$store.dispatch('getAccountDetail', {id: this.$route.params.id})
                        await this.$store.dispatch('customeraddresses_get', {parent_id: this.$route.params.cid})
                        break;
                    case 'PanelUser':
                        params.type = 0;
                        break;
                    case 'PanelUserLDAP':
                        params.type = 0;
                        break;
                    case 'Tracing':
                        this.$store.dispatch('getTracings', {accountId: this.$route.params.id})
                        break;
                }
                if((form).toLowerCase() !== 'general' && (form).toLowerCase() !== 'location'){
                    await this.$store.dispatch((form+'_get').toLowerCase(), params)
                }

                if(form == "WorkHours" || form == "WorkHoursEdit" || form == "WorkHoursModal"){
                    this.tolerans = true
                    await this.$store.dispatch('workhourstolerance_get', params)
                }else
                    this.tolerans = false
            },
            saveData: async function(){
                switch(this.currentForm){
                    case "General":
                        this.$refs.GeneralForm.$refs.Form.validate().then(async success =>{
                            if(success){
                                let data =  prepareRequestData(this.GeneralForms, this.$refs.GeneralForm.formData)
                                data.id =  this.$route.params.id
                                await this.$store.dispatch('account_edit', data)
                                if(this.$store.getters.getAccountStatus.status == 'Success')
                                    await this.$store.dispatch('getAccountDetail', {id: this.$route.params.id})
                                    
                            }else{
                                return false
                            }
                        })
                        break;
                }
            }
        },
        
    }
</script>

<style lang="css" scoped> 
    @import "./styles/edit.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/Edit.vue